import React from 'react'
import FilterButton from '../../../../components/buttons/FilterButton'

const GestaoOpenButton = ({ ...props }) => (
  <FilterButton color="white" {...props} text="Processar Relatórios" />
)
export default GestaoOpenButton
